module.exports = __webpack_public_path__ + "img/closePanel.06eee5f2.jpg";